import React from 'react';
import ReactDOM from 'react-dom/client';
import { LicenseInfo } from '@mui/x-license';
// Third party
import {
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux/es/exports';
import { PersistGate } from 'redux-persist/integration/react';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { faShopify, faHive } from '@fortawesome/free-brands-svg-icons';
import { Crisp } from 'crisp-sdk-web';
import { PostHogProvider } from 'posthog-js/react';

// Components
import { loadIcons } from '@iconify/react';
import { SYSTEM_ICONS } from '@mgm/common/data';
import App from './App';

// Redux-toolkit
import { store, persistor } from './store';

// Style
import './assets/css/common.css';

// LIB
import './lib/i18n';
import {
  CRISP_ID, MUI_KEY, PUBLIC_POSTHOG_KEY, PUBLIC_POSTHOG_HOST,
} from '../config';
import { initSentry } from './lib/sentry';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
    },
  },
});

if (import.meta.env.MODE === 'production') {
  initSentry();
  Crisp.configure(CRISP_ID);
}

loadIcons(SYSTEM_ICONS);

library.add(fas, far, faShopify, faHive);

LicenseInfo.setLicenseKey(MUI_KEY);

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <PostHogProvider
      apiKey={PUBLIC_POSTHOG_KEY}
      options={{
        api_host: PUBLIC_POSTHOG_HOST,
        // debug: import.meta.env.MODE === 'development',
      }}
    >
      <HelmetProvider>
        <Provider store={store}>
          <QueryClientProvider client={queryClient}>
            <BrowserRouter>
              <PersistGate loading={null} persistor={persistor}>
                <App />
              </PersistGate>
            </BrowserRouter>
            {import.meta.env.MODE === 'development' && <ReactQueryDevtools />}
          </QueryClientProvider>
        </Provider>
      </HelmetProvider>
    </PostHogProvider>
  </React.StrictMode>,
);
